(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-schnellwahl-kreise"] && !Shopify.designMode) return;
  try {
    (() => {
    // Wichtig: Das Theme tauscht Abschnitte im Betrieb aus (Filter, Instant-Navigation).
    // Direkt an den Knoepfen haengende Listener gehen dabei verloren - deshalb delegieren
    // wir Klick und Scroll am document und merken uns beobachtete Listen ueber ein WeakSet.
    const beobachtet = new WeakSet();

    const pfeileAktualisieren = (liste) => {
      const rahmen = liste.closest('.schnellwahl-kreise__rahmen');
      if (!rahmen) return;
      const zurueck = rahmen.querySelector('[data-richtung="zurueck"]');
      const vor = rahmen.querySelector('[data-richtung="vor"]');
      if (!zurueck || !vor) return;
      const rest = liste.scrollWidth - liste.clientWidth;
      const ueberlauf = rest > 4;
      zurueck.hidden = !ueberlauf || liste.scrollLeft <= 2;
      vor.hidden = !ueberlauf || liste.scrollLeft >= rest - 2;
    };

    // Beim Laden den aktiven Kreis in den sichtbaren Bereich schieben - sonst steht die
    // Markierung bei langen Reihen ausserhalb und niemand sieht, wo er gerade ist.
    // Nur horizontal in der Reihe selbst, kein scrollIntoView (das wuerde die Seite springen lassen).
    const ausrichten = () => {
      document.querySelectorAll('.schnellwahl-kreise__liste').forEach((liste) => {
        if (!beobachtet.has(liste)) {
          beobachtet.add(liste);
          if (typeof ResizeObserver === 'function') {
            new ResizeObserver(() => pfeileAktualisieren(liste)).observe(liste);
          }
        }

        const aktiv = liste.querySelector('[aria-current="page"]');
        if (!aktiv) {
          pfeileAktualisieren(liste);
          return;
        }
        const punkt = aktiv.closest('li') || aktiv;
        const listeBox = liste.getBoundingClientRect();
        const punktBox = punkt.getBoundingClientRect();
        const links = punktBox.left - listeBox.left + liste.scrollLeft;
        const sicht = liste.clientWidth;
        const passt = links >= liste.scrollLeft && links + punktBox.width <= liste.scrollLeft + sicht;
        if (punktBox.width < sicht && !passt) {
          liste.scrollLeft = Math.max(0, Math.round(links - (sicht - punktBox.width) / 2));
        }
        pfeileAktualisieren(liste);
      });
    };

    document.addEventListener('click', (ereignis) => {
      const knopf = ereignis.target.closest && ereignis.target.closest('.schnellwahl-kreise__pfeil');
      if (!knopf) return;
      const rahmen = knopf.closest('.schnellwahl-kreise__rahmen');
      const liste = rahmen && rahmen.querySelector('.schnellwahl-kreise__liste');
      if (!liste) return;
      const weite = Math.max(160, Math.round(liste.clientWidth * 0.8));
      liste.scrollBy({ left: knopf.dataset.richtung === 'vor' ? weite : -weite, behavior: 'smooth' });
    });

    // Klickmessung (siehe Kopfkommentar). pointerdown deckt Maus, Touch, Mittelklick und
    // Kontextmenue "in neuem Tab" ab, click die Tastatur. Capture-Phase, damit der Parameter
    // gesetzt ist, bevor irgendein anderer Handler die Navigation uebernimmt.
    const klickMarkieren = (ereignis) => {
      const link = ereignis.target.closest && ereignis.target.closest('.schnellwahl-kreise__link');
      if (!link || link.getAttribute('aria-current') === 'page') return;
      try {
        const url = new URL(link.href, window.location.href);
        if (url.searchParams.get('kreis') === '1') return;
        url.searchParams.set('kreis', '1');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (fehler) {
        // Messung darf die Navigation nie verhindern.
      }
    };
    document.addEventListener('pointerdown', klickMarkieren, true);
    document.addEventListener('click', klickMarkieren, true);

    document.addEventListener('scroll', (ereignis) => {
      const ziel = ereignis.target;
      if (ziel instanceof Element && ziel.classList.contains('schnellwahl-kreise__liste')) {
        pfeileAktualisieren(ziel);
      }
    }, true);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ausrichten, { once: true });
    } else {
      ausrichten();
    }
    window.addEventListener('load', ausrichten);
    window.addEventListener('pageshow', ausrichten);
    document.addEventListener('shopify:section:load', ausrichten);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-tag-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-tag-disclosure')) {
    class CollectionTagDisclosure extends HTMLElement {
      static expanded = new Map();
      connectedCallback() {
        this.disclosure = this.querySelector('details');
        if (!this.disclosure) return;
        this.disclosure.open = CollectionTagDisclosure.expanded.get(this.id) === true;
        this.onToggle = () => CollectionTagDisclosure.expanded.set(this.id, this.disclosure.open);
        this.disclosure.addEventListener('toggle', this.onToggle);
      }
      disconnectedCallback() {
        this.disclosure?.removeEventListener('toggle', this.onToggle);
      }
    }
    customElements.define('collection-tag-disclosure', CollectionTagDisclosure);
  }
  } catch(e) { console.error(e); }
})();

})();
